import { FC } from 'react'
import styled from 'styled-components'
import useIsMobile from '@app.modules/hooks/useIsMobile'
import { mobileBreakPoint } from 'app.styled/media'

interface IFProps {
  selectedTab: string
  Tabs: {
    ACTIVITY: string
    CHANNEL: string
    COMMUNITY: string
    CHAT: string
  }
}

const EmptyNotificationDescription: FC<IFProps> = ({ selectedTab, Tabs }) => {
  const isMobile = useIsMobile()

  return (
    <StyledWrapper>
      {selectedTab === Tabs.ACTIVITY && (
        <>
          {isMobile ? (
            <>
              <div className="desc">
                대외활동을 스크랩하고, 합격자료&커뮤니티에
              </div>
              <div className="desc">글을 작성해보세요.</div>
            </>
          ) : (
            <>
              <div className="desc">관심있는 기업의 공고를 탐색하고</div>
              <div className="desc">공고를 스크랩해보세요.</div>
            </>
          )}
        </>
      )}
      {selectedTab === Tabs.CHANNEL && (
        <>
          <div className="desc">관심있는 기업채널을 탐색하고</div>
          <div className="desc">채널을 팔로우해보세요.</div>
        </>
      )}
      {selectedTab === Tabs.COMMUNITY && (
        <>
          <div className="desc">지금 가장 인기있는</div>
          <div className="desc">커뮤니티 글을 확인해보세요.</div>
        </>
      )}
      {selectedTab === Tabs.CHAT && (
        <>
          <div className="desc">채팅방에서 궁금한 채용정보를</div>
          <div className="desc">실시간으로 확인해보세요.</div>
        </>
      )}
    </StyledWrapper>
  )
}

export default EmptyNotificationDescription

const StyledWrapper = styled.div`
  padding: 7px 0 32px;
  .desc {
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: -0.48px;
    text-align: center;
    color: #999;
  }

  ${mobileBreakPoint} {
    padding: 10px 0 20px;
    .desc {
      font-size: 15px;
      line-height: 1.33;
      letter-spacing: -0.6px;
    }
  }
`
